import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20panels%20collage%20abstract%20background%2C%20warm%20vibrant%20colorful%20illustration%2C%20soft%20gradient%20overlay%2C%20digital%20art%20style%2C%20clean%20modern%20composition%2C%20editorial%20quality%2C%20atmospheric%20warm%20lighting%2C%20webtoon%20aesthetic%20backdrop%2C%20no%20readable%20text&width=1920&height=700&seq=cta-bg-home&orientation=landscape"
          alt="韩漫阅读背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/40 to-foreground-950/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight mb-6">
              准备好了吗？
              <br />
              开启你的韩漫之旅
            </h2>
            <Link
              to="/category/hot"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-background-50 text-foreground-950 hover:bg-background-100 px-8 py-3 rounded-full text-sm font-medium cursor-pointer transition-colors"
            >
              立即开始阅读
              <span className="w-6 h-6 flex items-center justify-center bg-foreground-950 rounded-full">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </Link>
          </div>
          <div className="text-right">
            <p className="text-background-50/70 text-sm leading-relaxed max-w-sm ml-auto">
              超过3200部韩国漫画等你探索<br />
              全部免费 · 每日更新 · 高清画质
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}